class TeamDelegate {
    setNewMemberEmail(newMemberEmail) {
        this.setState((prev) => ({
            newMemberEmail,
            inviteError: prev.inviteError ? '' : prev.inviteError,
        }));
    }

    /** @param {string} newMemberRoleId - roles.id of the role to invite/assign */
    setNewMemberRole(newMemberRoleId) {
        this.setState((prev) => ({
            newMemberRole: newMemberRoleId,
            inviteError: prev.inviteError ? '' : prev.inviteError,
        }));
    }

    setInviteError(inviteError) {
        this.setState({ inviteError });
    }
}

export default TeamDelegate;
